// Quelle: /opt/webgis/frontend/src/app/Logo.tsx (Stand 2026-09-29)
// Geändert (SPEC 03 §3.1): nur noch die Wortmarke als <img src="/logo.svg" alt="LILASp"> mit
// filter: var(--logo-filter) (hellt sie im Dunkeln auf); kein Inline-SVG, kein
// roh eingesetztes HTML. Kachel und Produktwort setzt die Kopfleiste selbst (.marke).
export function Logo({ className = "logo", hoehe }: { className?: string; hoehe?: number }) {
  return (
    <img
      src="/logo.svg"
      alt="LILASp"
      className={className}
      draggable={false}
      style={{ height: hoehe, width: "auto", display: "block", filter: "var(--logo-filter, none)" }}
    />
  );
}
